import { LoaderFunctionArgs } from 'react-router-dom'
import { store } from '../../store'
import { getTest, listQuizTopics } from '../../action/quizes'
import { listTags } from '../../action/tags'
import { listDefaultExperiencePoints } from "../../action/gamification"

export const testLoader = async ( args: LoaderFunctionArgs ) => {

    await listDefaultExperiencePoints()

    await listTags()

    await listQuizTopics()

    if ( args.params.id ) {

        await getTest( parseInt( args.params.id ) )

    } else {

        store.dispatch( {
            type: `SET_QUIZ_TYPE`,
            quizType: `test`
        } )
        store.dispatch( {
            type: `GET_QUIZ_OK`,
            quiz: null,
            experience: store.getState().gamification.defaultExperiencePoints.find( d => d.name === `testexperience` )?.experience || 200
        } )

    }

}